import m from "mithril";

/**
 * Translations are objects keep data asi translations.lang.key = value
 */
type Translations = {[lang:string]: {[key:string]: string}};

export class Dictionary {

    public static readonly TRANSLATION_DELIMITER = '~~';

    private readonly translations: Translations;
    private _locale?: string;

    constructor(translations: Translations, locale?: string) {
        this.translations = translations;
        this._locale = locale;
    }

    get locale(): string|undefined {
        return this._locale;
    }

    set locale(locale: string|undefined) {
        this._locale = locale;
        m.redraw();
    }

    public locales(): string[] {
        return this.translations ? Object.keys(this.translations) : [];
    }

    public translate(message: string): string {
        const parts = message.split(Dictionary.TRANSLATION_DELIMITER);
        for (let i=1; i+1<parts.length; i+=2) {
            parts[i] = this.searchTranslation(parts[i]);
        }
        return parts.join('');
    }

    private searchTranslation(word: string): string {
        if (this.translations && this._locale) {
            const translations = this.translations;
            if (translations[this._locale]) {
                const lang = translations[this._locale];
                if (lang[word]) {
                    return lang[word];
                }
            }
        }

        return Dictionary.TRANSLATION_DELIMITER + word + Dictionary.TRANSLATION_DELIMITER;
    }

}
